<template>
    <van-action-sheet v-model:show="showContact" title="联系客服" :close-on-click-overlay="true" @close="handleClose">
        <div class="contact-content">
            <div class="contact-item phone-item">
                <div class="icon-wrapper" @click="handleCall">
                    <van-icon name="phone" class="contact-icon" color="#8B0000" />
                </div>
                <div class="info">
                    <div class="contact-label">
                        客服电话：<span class="phone-number" @click="handleCall">{{ phone }}</span>
                    </div>
                    <div class="contact-time">服务时间：{{ serviceTime }}</div>
                </div>
            </div>
        </div>
    </van-action-sheet>
</template>

<script setup>
import { computed } from 'vue'
import { Toast } from 'vant'

// Props
const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    phone: {
        type: String,
        default: ''
    },
    serviceTime: {
        type: String,
        default: ''
    },
})

// Emits
const emit = defineEmits(['update:show'])

// 计算属性
const showContact = computed({
    get() {
        return props.show
    },
    set(value) {
        emit('update:show', value)
    }
})

// 关闭弹框
const handleClose = () => {
    emit('update:show', false)
}

// 拨打电话
const handleCall = () => {
    if (!props.phone) {
        Toast('电话号码不存在')
        return
    }
    window.location.href = `tel:${props.phone}`
}
</script>

<style scoped>
.contact-content {
    padding: 0 16px 20px;
}

.contact-item {
    display: flex;
    align-items: flex-start;
    padding: 16px 0;
    border-bottom: 1px solid #F6F6F6;
    cursor: pointer;
}

.contact-item:last-child {
    border-bottom: none;
}

.icon-wrapper {
    width: 24px;
    height: 24px;
    margin-right: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contact-icon {
    font-size: 24px;
}

.info {
    flex: 1;
}

.contact-label {
    font-size: 16px;
    color: #333;
    margin-bottom: 6px;
}

.phone-number {
    color: var(--van-primary-color);
    font-weight: 500;
}

.contact-time {
    font-size: 14px;
    color: #979797;
}
</style>